import React, { useEffect, useState, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Autocomplete,
  Typography,
  alpha,
  Divider,
} from "@mui/material";
import { countries } from "../constants";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import IDTier2 from "./IDTier2";
import CloseIcon from "@mui/icons-material/Close";
import {
  allowOnlyAlphabetsCityState,
  OnlyAllowedInput,
  OnlyAllowedInputHouse,
  OnlyAllowedInputStreet,
  OnlyAllowedInputZipCode,
  OnlyAllowedZipCode,
} from ".";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import CustomCircleCheck from "../../Common/CircleCheck";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";

const BeneficialOwners = ({
  handleSteps,
  handleBack,
  userDetails,
  setIsloading,
  steps,
  payload,
}) => {
  const theme = localStorage.getItem("theme");
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const [userInfo, setUserInfo] = useState("");
  const uuid = localStorage.getItem("uuid");
  const token = localStorage.getItem("access_token");
  const userId = localStorage.getItem("userId");
  const [open, setOpen] = useState(false);
  const [PEPOpen, setPEPOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [finalKycModal, setFinalKycModal] = useState(false);
  const [payloadSecond, setPayloadSecond] = useState({ ...payload });
  const [owners, setOwners] = useState([]);
  const [autoFill, setAutoFill] = useState(null);
  const [enterpriseUser, setEnterpriceUser] = useState([]);
  const [dob, setDob] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [countryFlag, setCountryFlag] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCountries, setFilterCountry] = useState([]);
  const [formValues, setFormValues] = useState();
  const [totalOwnership, setTotalOwnership] = useState(0);
  const [sameCredConfirmation, setSameCredConfirmation] = useState(false);
  const [sameUserConfirmation, setSameUserConfirmation] = useState(false);

  const handleCloseConfirmModal = () => setConfirmModal(false);
  const handleCloseKYCModal = () => setFinalKycModal(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isValid },
    setValue,
    watch,
    reset,
    trigger,
    setError,
    clearErrors,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      ownerType: "Authorized signatory",
      autofill: "Select any",
      country: "Select any",
      pep: "No",
    },
  });

  useEffect(() => {
    getCountryFlag();
  }, []);
  useEffect(() => {
    if (payload) {
      getUserDetails();
    }
  }, [payload, confirmModal]);
  useEffect(() => {
    register("dob", {
      required: "Date of birth is required",
      validate: validateDobfunc,
    });
  }, [register]);

  const setRole = (e) => {
    const filterData = owners?.filter((x) => x.ownerType === e);
    setEnterpriceUser(filterData);
  };

  const handleAutoFillChange = (index) => {
    const data = enterpriseUser[index];
    if (!data) return;
    const indexOfComma = data?.address.indexOf(",");
    console.log("Autofill data:", new Date(data?.dob));
    setValue("firstname", data?.firstName || "");
    setValue("middlename", data?.middleName || "");
    setValue("lastname", data?.lastName || "");
    setValue("email", data?.email || "");
    setValue("phone", data?.phone || "");
    setValue("houseNo", data?.address?.substring(0, indexOfComma).trim() || "");
    setValue("street", data?.address.substring(indexOfComma + 1).trim() || "");
    setValue("dob", new Date(data?.dob) || "");
    setValue("city", data?.city || "");
    setValue("state", data?.state || "");
    setValue("country", data?.country || "");
    setValue("zipcode", data?.zip || "");
    setValue("dob", data?.dob || "");
    setValue("birthPlace", data?.birthPlace || "");
    setValue("ssn", data?.ssn || "");
    setValue("ownerShip", data?.ownershipPer || "");
    setValue("pep", data?.pep === 1 ? "Yes" : "No");
    setDob(new Date(data?.dob));
  };

  const getUserDetails = async () => {
    const data = { userId: userId, uuid: uuid };
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        data,
        { headers: { Authorization: `BEARER ${token}` } }
      );
      setUserInfo(response?.data?.userResult);
      setOwners(
        response?.data?.userResult?.enterpriseUser?.enterpriseOwners || []
      );
    } catch (err) {
      showToast("error", err?.response?.data?.error?.error_msg);
    }
  };

  const getCountryFlag = async () => {
    const response = await axios.get(
      `https://accounts.paybito.com/api/home/getExchangeCountries/${brokerBasicInfo.brokerId}`
    );
    const sortCountry = response?.data?.countries
      ?.sort((a, b) =>
        a.country.toLowerCase().localeCompare(b.country.toLowerCase())
      )
      ?.map((country) => ({
        value: country.dialCode,
        country: country.country,
        label: `(+${country.dialCode}) ${country.country}`,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
      }));
    setCountryFlag(sortCountry);
    setFilterCountry(sortCountry);
    setSelectedCountry(sortCountry[0]);
  };

  useEffect(() => {
    handleFilterCountry();
  }, [searchTerm]);

  const handleFilterCountry = useCallback(() => {
    if (searchTerm !== "") {
      const filteredData = countryFlag.filter(
        (country) =>
          country.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
          country.value.toString().includes(searchTerm)
      );
      setFilterCountry(filteredData);
    } else {
      setFilterCountry(countryFlag);
    }
  }, [searchTerm]);

  const handleClose = () => {
    reset();
    setOpen(false);
  };
  const handleClosePEP = () => {
    setPEPOpen(false);
  };

  useEffect(() => {
    if (userDetails?.enterpriseUser?.enterpriseOwners) {
      setOwners(userDetails?.enterpriseUser?.enterpriseOwners);
    }
  }, [userDetails]);

  console.log("userDetails", userDetails);

  const fileValidation = {
    required: "This field is required",
    validate: (fileList) => {
      console.log("fileList", fileList);
      if (!fileList || fileList.length === 0) return "This field is required";
      const file = fileList[0];
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jfif",
        "image/heic",
      ];
      if (!validTypes.includes(file.type)) return "Invalid file type";
      if (file.size > 6 * 1024 * 1024) return "MAX limit 6 MB.";
      return true;
    },
  };

  const optionalFileValidation = {
    validate: (fileList) => {
      if (!fileList || fileList.length === 0) return true;
      const file = fileList[0];
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jfif",
        "image/heic",
      ];
      if (!validTypes.includes(file.type)) return "Invalid file type";
      if (file.size > 6 * 1024 * 1024) return "MAX limit 6 MB.";
      return true;
    },
  };

  const onSubmit = async (data) => {
    setConfirmModal(true);
    setFormValues(data);
  };

  const saveOwnerCheckAndCall = async () => {
    try {
      setIsloading(true);
      let proceed = true;

      if (payload) {
        try {
          const response = await enterPriseDetailsAddBack(userInfo);
          console.log("response kyc", response);
          if (
            response?.data?.error?.error_data === 0 ||
            response?.data?.error?.error_data === 1
          ) {
            setIsloading(false);
          } else {
            showToast("warning", "Enterprise details failed, continuing...");
            proceed = false;
          }
        } catch (err) {
          console.error("Error in enterPriseDetailsAddBack:", err);
          showToast(
            "error",
            "Error while adding enterprise details. Continuing..."
          );
        }
      }

      if (proceed) {
        const data = formValues;
        const ownerPayload = {
          firstName: data?.firstname,
          middleName: data?.middlename || "",
          lastName: data?.lastname,
          address: `${data?.houseNo}, ${data?.street}`,
          city: data?.city,
          state: data?.state,
          zip: data?.zipcode,
          country: data?.country,
          phone: data?.phone,
          email: data?.email,
          ssn: data?.ssn,
          dob: data?.dob,
          birthPlace: data?.birthPlace,
          ownershipPer: data?.ownerShip,
          pep: data?.pep === "Yes" ? 1 : 0,
          action: "INSERT",
          ownerType: data?.ownerType,
        };

        const formData = new FormData();
        formData.append("owner", JSON.stringify(ownerPayload));
        formData.append("userUuid", uuid);
        if (data.frontId?.[0]) formData.append("idProofFront", data.frontId[0]);
        if (data.backId?.[0]) formData.append("idProofBack", data.backId[0]);
        if (data.addressProof?.[0])
          formData.append("addressProofDoc", data.addressProof[0]);
        if (data.selfie?.[0]) formData.append("selfieDoc", data.selfie[0]);
        if (data.investingFund?.[0])
          formData.append("investmentProofDoc", data.investingFund[0]);

        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }

        try {
          const response = await axios.post(
            `${WEBSERVICE}user/addEnterpriseOwner`,
            formData,
            { headers: { Authorization: `BEARER ${token}` } }
          );
          if (response.data.error.error_data === 0) {
            showToast("success", "User saved successfully!");
            getUserDetails();
            reset();
            setOpen(false);
            setConfirmModal(false);
            setSameUserConfirmation(false);
            setDob("");
          } else {
            showToast("error", response.data.error.error_msg);
          }
        } catch (err) {
          console.log("error", err);
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast("error", "Unexpected error occurred!");
    } finally {
      setIsloading(false);
    }
  };

  const handleConfirm = async () => {
    const data = formValues;
    const userNameCheck = owners?.filter(
      (x) =>
        x.ownerType?.toUpperCase() === data?.ownerType?.toUpperCase() &&
        x.firstName?.toUpperCase() === data?.firstname?.toUpperCase() &&
        x.lastName?.toUpperCase() === data?.lastname?.toUpperCase()
    );
    const userCredCheck = owners?.filter(
      (x) =>
        x.ownerType === data?.ownerType &&
        (x.email?.toUpperCase() === data?.email?.toUpperCase() ||
          x.phone === data?.phone ||
          x.ssn === data?.ssn)
    );
    if (userCredCheck.length !== 0) {
      setSameCredConfirmation(true);
    } else {
      if (userNameCheck.length > 0) {
        setSameUserConfirmation(true);
      } else {
        saveOwnerCheckAndCall();
      }
    }
  };

  const validateDobfunc = (dobValue) => {
    console.log("dobValue", dobValue);
    if (!dobValue) return "Date of birth is required";
    const birthDate = new Date(dobValue);
    if (isNaN(birthDate)) return "Invalid date format";
    const today = new Date();
    const ageLimit = 18;
    const minAllowedDate = new Date(
      birthDate.getFullYear() + ageLimit,
      birthDate.getMonth(),
      birthDate.getDate()
    );
    if (today < minAllowedDate) return "You must be at least 18 years old";
    return true;
  };

  const handleBackshowmsg = () => {
    if (owners?.length === 0) {
      handleBack();
    } else {
      showToast(
        "error",
        "You cannot change the KYC details now as you already have submitted it"
      );
    }
  };

  const enterPriseDetailsAddBack = async (details) => {
    const formData = new FormData();
    const preliminarySaveObjectPayloadComp = {
      companyName: details?.enterpriseUser?.companyName,
      companyRegNo: details?.enterpriseUser?.companyRegNo,
      incorporationCountry: details?.enterpriseUser?.incorporationCountry,
      companyWebsite: details?.enterpriseUser?.companyWebsite,
      companyregAddress: details?.enterpriseUser?.companyregAddress,
      companyregCity: details?.enterpriseUser?.companyregCity,
      companyregState: details?.enterpriseUser?.companyregState,
      companyregZip: details?.enterpriseUser?.companyregZip,
      companyregCountry: details?.enterpriseUser?.companyregCountry,
      companyOfficeAddress: details?.enterpriseUser?.companyOfficeAddress,
      companyOfficeCity: details?.enterpriseUser?.companyOfficeCity,
      companyOfficeState: details?.enterpriseUser?.companyOfficeState,
      companyOfficeZip: details?.enterpriseUser?.companyOfficeZip,
      companyOfficeCountry: details?.enterpriseUser?.companyOfficeCountry,
      businessActivity: details?.enterpriseUser?.businessActivity,
      accountPurpose: details?.enterpriseUser?.accountPurpose,
      investmentSource: details?.enterpriseUser?.investmentSource,
      revenue: details?.enterpriseUser?.revenue,
      companyNetWorth: details?.enterpriseUser?.companyNetWorth,
      profit: details?.enterpriseUser?.profit,
      companyAssets: details?.enterpriseUser?.companyAssets,
      transactionVolumes: details?.enterpriseUser?.transactionVolumes,
      transactionFrequency: details?.enterpriseUser?.transactionFrequency,
      bankingPartner: details?.enterpriseUser?.bankingPartner,
      corporateStructure: details?.enterpriseUser?.corporateStructure,
      relationWithBank: details?.enterpriseUser?.relationWithBank,
      businessDescription: details?.enterpriseUser?.businessDescription,
    };

    formData.append(
      "enterpriseUser",
      JSON.stringify(preliminarySaveObjectPayloadComp)
    );
    formData.append(
      "incorporationCertificate",
      payload?.incorporationCertificate
    );
    formData.append("memorandum", payload?.memorandum);
    formData.append("associationArticles", payload?.associationArticles);
    formData.append("incumbencyCertificate", payload?.incumbencyCertificate);
    formData.append("directorsRegister", payload?.directorsRegister);
    formData.append("shareholdersRegister", payload?.shareholdersRegister);
    formData.append("boardResolution", payload?.boardResolution);
    formData.append("addressProof", payload?.addressProof);
    formData.append("wolfsbergDoc", payload?.wolfsbergDoc);
    formData.append("authorizationLetter", payload?.authorizationLetter);
    formData.append("uuid", localStorage.getItem("uuid"));

    setIsloading(true);
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/addUserEnterpriseDetails`,
        formData,
        {
          headers: {
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setIsloading(false);
      if (response.data.error.error_data !== 0) {
        return response;
      } else {
        return response;
      }
    } catch (error) {
      setIsloading(false);
    }
  };

  console.log("payload--->", payload);

  const handleDone = async () => {
    if (userDetails?.userDocsStatus !== "0") {
      await enterPriseDetailsAddBack(userInfo);
      callFinishKyc();
    } else {
      callFinishKyc();
    }
  };

  const callFinishKyc = () => {
    const identityObj = {};
    const jsonString = JSON.stringify(identityObj);
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    axios
      .post(`${WEBSERVICE}user/finishKyc?uuid=${uuid}`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.error?.error_data) {
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", "Your KYC process has been completed");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error finishing KYC:", error);
        showToast("error", "Something went wrong.");
      });
  };

  const handleAddOwnerOpen = () => {
    const sum = owners?.reduce(
      (acc, owner) => acc + (owner.ownershipPer || 0),
      0
    );
    console.log("toatlpercen", sum);
    setTotalOwnership(sum);
    setOpen(true);
  };

  const validateOwnership = (value) => {
    const val = parseFloat(value);
    console.log("ownerpercen", value, totalOwnership);
    if (isNaN(val)) return "Please enter a valid number";
    if (watch("ownerType") === "UBO") {
      if (val <= 0 || val > 100)
        return "Percentage should be greater than 0 and less than equal to 100";
    } else {
      if (val < 0 || val > 100)
        return "Percentage should be greater than 0 and less than equal to 100";
    }
    const remPer = 100 - totalOwnership;
    if (remPer < val) return "Total Percentage is greater than 100.";
  };

  const handleKeyPress = (e) => {
    const value = e.target.value;
    const key = e.key;
    if (
      e.ctrlKey ||
      e.metaKey ||
      [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
      ].includes(key)
    )
      return;
    if (!/[\d.]/.test(key)) {
      e.preventDefault();
      return;
    }
    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }
    const [integerPart, decimalPart] = value.split(".");
    if (!value.includes(".") && integerPart?.length >= 3 && key !== ".") {
      e.preventDefault();
      return;
    }
    if (value.includes(".") && /\d/.test(key)) {
      if (decimalPart && decimalPart.length >= 2) e.preventDefault();
    }
  };

  return (
    <>
      {steps === 5 && (
        <Box sx={card}>
          {/* Step Header */}
          <Box sx={stepHeader}>
            <Box
              sx={{
                ...stepBadge,
                backgroundColor: alpha(btncolor || "#1976d2", 0.12),
                color: btncolor,
              }}
            >
              <PeopleOutlinedIcon sx={{ fontSize: 18 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={stepTitle}>
                Identity Documents of Beneficial Owners
              </Typography>
              <Typography sx={stepCaption}>
                Add all primary owners with highest ownership percentages, and
                any owner with 10% or more.
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.13)", mb: 3 }} />

          {/* Info bullets */}
          <Box sx={{ mb: 3, display: "flex", flexDirection: "column", gap: 1 }}>
            {[
              "Please add all the primary owners with the highest ownership percentages and/or all owners whose ownership percentages are 10% or more.",
              "Adding a minimum of one owner is mandatory.",
            ].map((text, i) => (
              <Box
                key={i}
                sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
              >
                <CustomCircleCheck bgColor={btncolor} />
                <Typography
                  sx={{
                    fontSize: "0.84rem",
                    color: "var(--text-color)",
                    opacity: 0.65,
                    lineHeight: 1.5,
                  }}
                >
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <ContainedButton
            variant="contained"
            onClick={() => handleAddOwnerOpen()}
            sx={{
              ...submitBtn,
              mb: 3,
              display: "flex",
              alignItems: "center",
              gap: 0.75,
            }}
          >
            <PersonAddOutlinedIcon sx={{ fontSize: 18 }} />
            Add Owner
          </ContainedButton>

          {/* Owners Table */}
          <Typography
            sx={{
              fontSize: "0.82rem",
              fontWeight: 700,
              color: "var(--text-color)",
              opacity: 0.65,
              mb: 1.5,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Added Owners
          </Typography>
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
              borderRadius: "10px",
              border: "1px solid rgba(125,125,125,0.15)",
            }}
          >
            <table
              className="onwerDetails"
              style={{ minWidth: "800px", width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Owner type</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Country</th>
                  <th>SSN / Passport</th>
                  <th>Ownership %</th>
                  <th>PEP</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {owners?.length !== 0 ? (
                  owners?.map((owner, index) => (
                    <tr key={index}>
                      <td>{owner.ownerType}</td>
                      <td>{`${owner.firstName} ${
                        owner.middleName ? owner.middleName + " " : ""
                      }${owner.lastName}`}</td>
                      <td>{owner.email}</td>
                      <td>{owner.phone}</td>
                      <td>{owner.country}</td>
                      <td>{owner.ssn}</td>
                      <td>{owner.ownershipPer}</td>
                      <td>{owner.pep === 0 ? "No" : "Yes"}</td>
                      <td>{owner?.action || "In Review"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center">
                      No owners added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Box>

          {/* Add Owner Modal */}
          <ModalContent
            open={open}
            onClose={handleClose}
            title="Add New Owner"
            width="80%"
          >
            <form className="beneficial" onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3} justifyContent="center">
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                  <label className="text-secondary">Owner Type*</label>
                  <Controller
                    name="ownerType"
                    control={control}
                    rules={{
                      required: "Owner type is required",
                      validate: (value) =>
                        value !== "Select any" || "Please select an owner type",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={[
                          "Authorized signatory",
                          ...(owners?.length !== 0 ? ["Director", "UBO"] : []),
                        ]}
                        getOptionLabel={(option) => option || ""}
                        onChange={(_, data) => field.onChange(data)}
                        value={field.value || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select any"
                            error={!!errors.ownerType}
                            sx={autocompleteSx}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.ownerType && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.ownerType.message}
                    </span>
                  )}
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 9 }} />

                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <label className="text-secondary">
                      Auto-fill from {autoFill}
                    </label>
                    <div>
                      {watch("ownerType") !== "Authorized signatory" && (
                        <button
                          type="button"
                          className={`toggleBtn ${
                            autoFill === "Authorized signatory"
                              ? "toggleActive"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            setAutoFill("Authorized signatory");
                            setRole("Authorized signatory");
                          }}
                        >
                          Authorized signatory
                        </button>
                      )}
                      {watch("ownerType") !== "Director" && (
                        <button
                          type="button"
                          className={`toggleBtn ${
                            autoFill === "Director" ? "toggleActive" : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            setAutoFill("Director");
                            setRole("Director");
                          }}
                        >
                          Director
                        </button>
                      )}
                      {watch("ownerType") !== "UBO" && (
                        <button
                          type="button"
                          className={`toggleBtn ${
                            autoFill === "UBO" ? "toggleActive" : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            setAutoFill("UBO");
                            setRole("UBO");
                          }}
                        >
                          UBO
                        </button>
                      )}
                    </div>
                  </div>
                  <Autocomplete
                    options={enterpriseUser || []}
                    getOptionLabel={(option) =>
                      typeof option === "string"
                        ? option
                        : `${option?.firstName} ${option?.middleName} ${option?.lastName}` ||
                          ""
                    }
                    onChange={(_, data) => {
                      if (data) {
                        const index = enterpriseUser.indexOf(data);
                        handleAutoFillChange(index);
                      } else {
                        handleAutoFillChange("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select any"
                        sx={autocompleteSx}
                      />
                    )}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6 }} />

                {/* Name fields */}
                {[
                  {
                    key: "firstname",
                    label: "First name*",
                    required: "First name is required",
                    pattern: {
                      value: /^[A-Za-z]+$/i,
                      message: "First name should contain only letters",
                    },
                  },
                  {
                    key: "middlename",
                    label: "Middle name",
                    required: false,
                    pattern: {
                      value: /^[A-Za-z]*$/i,
                      message: "Middle name should contain only letters",
                    },
                  },
                  {
                    key: "lastname",
                    label: "Last name*",
                    required: "Last name is required",
                    pattern: {
                      value: /^[A-Za-z]+$/i,
                      message: "Last name should contain only letters",
                    },
                  },
                ].map(({ key, label, required, pattern }) => (
                  <Grid key={key} size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="text-secondary">{label}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      className={`beneficial_dropdown ${
                        errors[key] ? "error-border" : ""
                      }`}
                      placeholder={`Enter ${label
                        .replace("*", "")
                        .trim()
                        .toLowerCase()}`}
                      {...register(key, { required, pattern })}
                      onKeyDown={allowOnlyAlphabetsCityState}
                      onBlur={() => trigger(key)}
                    />
                    {errors[key] && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {errors[key].message}
                      </span>
                    )}
                  </Grid>
                ))}

                {/* Email */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">Email*</label>
                  <input
                    autoComplete="off"
                    type="email"
                    className={`beneficial_dropdown ${
                      errors.email ? "error-border" : ""
                    }`}
                    placeholder="Enter email id"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                    onBlur={() => trigger("email")}
                  />
                  {errors.email && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.email.message}
                    </span>
                  )}
                </Grid>

                {/* Phone */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">Phone*</label>
                  <div style={{ position: "relative", display: "flex" }}>
                    <div
                      onClick={() => setIsOpen(!isOpen)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "5px",
                        border: "1px solid black",
                        cursor: "pointer",
                        width: "60px",
                      }}
                    >
                      <img
                        src={selectedCountry?.flag || countryFlag[0]?.flag}
                        alt={selectedCountry?.code || countryFlag[0]?.code}
                      />
                    </div>
                    <input
                      autoComplete="off"
                      type="number"
                      className="beneficial_dropdown"
                      style={{ borderRadius: "0px" }}
                      {...register("phone", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Only numbers are allowed",
                        },
                        minLength: {
                          value: 8,
                          message: "Phone number must be at least 8 digits",
                        },
                        maxLength: {
                          value: 15,
                          message: "Phone number must be at most 15 digits",
                        },
                      })}
                      onKeyDown={(e) => {
                        if (
                          !/^\d$/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "Tab"
                        )
                          e.preventDefault();
                      }}
                      inputMode="numeric"
                      onBlur={() => trigger("phone")}
                    />
                    {isOpen && (
                      <div
                        className="countryFlag"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          width: "250px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          background: "#black",
                          zIndex: 1000,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        <input
                          autoComplete="off"
                          type="text"
                          placeholder="Search country"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="search_country_"
                        />
                        {filteredCountries && filteredCountries.length !== 0 ? (
                          filteredCountries.map((country) => (
                            <div
                              onClick={() => {
                                setSelectedCountry(country);
                                setIsOpen(false);
                              }}
                              className="search_country_"
                            >
                              <img src={country?.flag} alt={country?.code} />
                              &nbsp;
                              <span
                                style={{ color: "#555" }}
                              >{`+(${country?.value})`}</span>
                              <span
                                style={{ marginLeft: "10px", color: "#555" }}
                              >
                                {country?.country}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "10px", color: "#888" }}>
                            No results found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {errors.phone && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.phone.message}
                    </span>
                  )}
                </Grid>

                {/* House / Street / City / State */}
                {[
                  {
                    key: "houseNo",
                    label: "House no./Apt no.*",
                    required: "House/Apt number is required",
                    handler: OnlyAllowedInputHouse,
                  },
                  {
                    key: "street",
                    label: "Street/Area*",
                    required: "Street/Area is required",
                    handler: OnlyAllowedInputStreet,
                  },
                  {
                    key: "city",
                    label: "City*",
                    required: "City is required",
                    handler: allowOnlyAlphabetsCityState,
                  },
                  {
                    key: "state",
                    label: "State, Region, or Province*",
                    required: "State/Region/Province is required",
                    handler: allowOnlyAlphabetsCityState,
                  },
                ].map(({ key, label, required, handler }) => (
                  <Grid key={key} size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="text-secondary">{label}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      className={`beneficial_dropdown ${
                        errors[key] ? "error-border" : ""
                      }`}
                      placeholder={`Enter ${label
                        .replace("*", "")
                        .trim()
                        .toLowerCase()}`}
                      {...register(key, { required })}
                      onKeyDown={handler}
                      onBlur={() => trigger(key)}
                    />
                    {errors[key] && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {errors[key].message}
                      </span>
                    )}
                  </Grid>
                ))}

                {/* Country */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">Country*</label>
                  <Controller
                    name="country"
                    control={control}
                    rules={{
                      required: "Country is required",
                      validate: (value) =>
                        value !== "Select any" || "Please select a country",
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={countries}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option.name || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          typeof value === "string"
                            ? option.name === value
                            : option.name === value.name
                        }
                        value={
                          countries.find((c) => c.name === field.value) ||
                          field.value ||
                          null
                        }
                        onChange={(_, data) =>
                          field.onChange(data ? data.name : "")
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select any"
                            error={!!errors.country}
                            sx={autocompleteSx}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.country && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.country.message}
                    </span>
                  )}
                </Grid>

                {/* Zip */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">Zip Code/Pin Code*</label>
                  <input
                    autoComplete="off"
                    type="text"
                    className={`beneficial_dropdown ${
                      errors.zipcode ? "error-border" : ""
                    }`}
                    placeholder="Enter Zip or PIN code"
                    {...register("zipcode", {
                      required: "Zip/Pin code is required",
                      pattern: {
                        value: /^[a-zA-Z0-9 ]*$/,
                        message: "Invalid zip/pin code",
                      },
                    })}
                    onKeyDown={OnlyAllowedZipCode}
                    onBlur={() => trigger("zipcode")}
                  />
                  {errors.zipcode && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.zipcode.message}
                    </span>
                  )}
                </Grid>

                {/* DOB */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">Date of Birth*</label>
                  <br />
                  <input
                    type="date"
                    value={dob ? new Date(dob).toISOString().split("T")[0] : ""}
                    onChange={(e) => {
                      const selectedDate = e.target.value
                        ? new Date(e.target.value)
                        : null;
                      setValue("dob", selectedDate);
                      setDob(selectedDate);
                      const validation = validateDobfunc(selectedDate);
                      if (validation !== true) {
                        setError("dob", {
                          type: "manual",
                          message: validation,
                        });
                      } else {
                        clearErrors("dob");
                      }
                    }}
                    onBlur={() => trigger("dob")}
                    className={`beneficial_dropdown ${
                      errors.dob ? "error-border" : ""
                    }`}
                    placeholder="Select your date of birth"
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: errors.dob
                        ? "1px solid red"
                        : "1px solid #ced4da",
                      color: "#495057",
                      backgroundColor: "#fff",
                    }}
                  />
                  {errors.dob && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.dob.message}
                    </span>
                  )}
                </Grid>

                {/* Place of birth / SSN / Ownership */}
                {[
                  {
                    key: "birthPlace",
                    label: "Place of birth*",
                    required: "Place of birth is required",
                    pattern: {
                      value: /^[A-Za-z\s]+$/i,
                      message: "Place of birth should contain only letters",
                    },
                    handler: allowOnlyAlphabetsCityState,
                  },
                  {
                    key: "ssn",
                    label: "SSN or Passport Number*",
                    required: "SSN/Passport is required",
                    pattern: {
                      value: /^[A-Za-z0-9-]+$/i,
                      message: "Invalid SSN/Passport format",
                    },
                    handler: OnlyAllowedInputZipCode,
                  },
                ].map(({ key, label, required, pattern, handler }) => (
                  <Grid key={key} size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="text-secondary">{label}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      className={`beneficial_dropdown ${
                        errors[key] ? "error-border" : ""
                      }`}
                      placeholder={`Enter ${label
                        .replace("*", "")
                        .trim()
                        .toLowerCase()}`}
                      {...register(key, {
                        required,
                        pattern,
                        ...(key === "ssn"
                          ? {
                              maxLength: {
                                value: 15,
                                message: "Must be not more than 15 characters",
                              },
                            }
                          : {}),
                      })}
                      onKeyDown={handler}
                      onBlur={() => trigger(key)}
                      maxLength={key === "ssn" ? 15 : undefined}
                    />
                    {errors[key] && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {errors[key].message}
                      </span>
                    )}
                  </Grid>
                ))}

                {/* Ownership % */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">
                    Percentage ownership*
                  </label>
                  <input
                    autoComplete="off"
                    type="number"
                    min="0"
                    max="100"
                    step="any"
                    className={`beneficial_dropdown ${
                      errors.ownerShip ? "error-border" : ""
                    }`}
                    placeholder="Enter percentage ownership"
                    {...register("ownerShip", {
                      required: "Ownership percentage is required",
                      validate: validateOwnership,
                    })}
                    onBlur={() => trigger("ownerShip")}
                    onWheel={(e) => e.target.blur()}
                    onKeyDown={handleKeyPress}
                  />
                  {errors.ownerShip && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.ownerShip.message}
                    </span>
                  )}
                </Grid>

                {/* PEP */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">
                    Are you a Politically Exposed Person (PEP)?&nbsp;
                    <a href="#" onClick={() => setPEPOpen(true)}>
                      Who is a PEP?
                    </a>
                    <span style={{ visibility: "hidden" }}>
                      ID or driver's license
                    </span>
                  </label>
                  <Controller
                    name="pep"
                    control={control}
                    rules={{ required: "PEP status is required" }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={["No", "Yes"]}
                        getOptionLabel={(option) => option || ""}
                        onChange={(_, data) => field.onChange(data)}
                        value={field.value || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select any"
                            error={!!errors.pep}
                            sx={autocompleteSx}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.pep && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.pep.message}
                    </span>
                  )}
                </Grid>

                {/* File uploads for owner */}
                {[
                  {
                    key: "frontId",
                    label:
                      "Front side of identification proof (such as passport, national ID or driver's license)*",
                  },
                  {
                    key: "backId",
                    label:
                      "Back side of identification proof (such as passport, national ID or driver's license)*",
                  },
                  {
                    key: "addressProof",
                    label:
                      "Proof of Address of Ultimate Beneficial Owners (UBOs)*",
                  },
                  {
                    key: "selfie",
                    label:
                      "Selfie with holding their identity documents of the Beneficial Owners*",
                  },
                ].map(({ key, label }) => (
                  <Grid key={key} size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="text-secondary">{label}</label>
                    <div
                      className={`beneficial_dropdown_file ${
                        errors[key] ? "error-border" : ""
                      }`}
                    >
                      <input
                        autoComplete="off"
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.jfif,.heic"
                        onChange={(e) => {
                          const fileList = e.target.files;
                          setValue(key, fileList);
                          trigger(key);
                        }}
                        {...register(key, fileValidation)}
                      />
                    </div>
                    {errors[key] && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px" }}
                      >
                        {errors[key].message}
                      </span>
                    )}
                  </Grid>
                ))}

                {/* Optional: Investment proof */}
                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                  <label className="text-secondary">
                    Proof of document supporting the source of investment funds
                    (if necessary)
                  </label>
                  <div
                    className={`beneficial_dropdown_file ${
                      errors.investingFund ? "error-border" : ""
                    }`}
                  >
                    <input
                      autoComplete="off"
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.jfif,.heic"
                      onChange={(e) => {
                        const fileList = e.target.files;
                        setValue("investingFund", fileList);
                        trigger("investingFund");
                      }}
                      {...register("investingFund", optionalFileValidation)}
                    />
                  </div>
                  {errors.investingFund && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.investingFund.message}
                    </span>
                  )}
                </Grid>

                <Grid size={12} className="d-flex justify-content-end mt-4">
                  <OutlinedButton
                    type="button"
                    variant="outlined"
                    style={{
                      textTransform: "none",
                      borderRadius: "20px",
                      marginRight: "10px",
                    }}
                    onClick={handleClose}
                  >
                    Cancel
                  </OutlinedButton>
                  <ContainedButton
                    type="submit"
                    variant="contained"
                    style={{ textTransform: "none", borderRadius: "20px" }}
                  >
                    Submit UBO info
                  </ContainedButton>
                </Grid>
              </Grid>
            </form>
          </ModalContent>

          {/* Confirm Modal */}
          <ModalContent open={confirmModal} onClose={handleCloseConfirmModal}>
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={{ textAlign: "center" }}
            >
              Warning
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 2, px: 2, textAlign: "justify" }}
            >
              You are about to submit UBO information. If you click Submit, the
              info would be submitted for review. You won't be able to edit the
              info any more. Are you sure you would like to submit?
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <ContainedButton
                variant="contained"
                onClick={handleConfirm}
                sx={{ mr: 1 }}
              >
                Submit
              </ContainedButton>
              <ContainedButton
                variant="contained"
                onClick={handleCloseConfirmModal}
              >
                Cancel and edit
              </ContainedButton>
            </Box>
          </ModalContent>

          {/* Final KYC Modal */}
          <ModalContent
            open={finalKycModal}
            onClose={handleCloseKYCModal}
            title="Warning"
          >
            <Typography variant="body1" sx={{ mt: 2, textAlign: "justify" }}>
              Are you sure you have added all the required owners? You will be
              navigating away from this page and your KYC will be sent for
              review. You will not be able to add more owners later.
            </Typography>
            <div className="mt-3 d-flex justify-content-between">
              <OutlinedButton
                variant="outlined"
                onClick={() => {
                  handleDone();
                  handleCloseKYCModal();
                }}
              >
                I am done
              </OutlinedButton>
              <ContainedButton
                variant="contained"
                onClick={handleCloseKYCModal}
              >
                I want to add more owners
              </ContainedButton>
            </div>
          </ModalContent>

          {/* PEP Info Modal */}
          <ModalContent
            open={PEPOpen}
            onClose={handleClosePEP}
            title="Who is a PEP?"
            width="md"
          >
            <Typography gutterBottom>
              <b>A politically exposed person (PEP)</b> including Head of
              International Organization ("HIO"), is "an individual who is or
              has been entrusted with a prominent public position. A PEP can be
              either "Foreign" or "Domestic".
            </Typography>
            <br />
            <Typography gutterBottom>
              <b>Head of International Organization (HIO)</b>
            </Typography>
            <br />
            <Typography gutterBottom>
              HIO is an individual heading an international organization that is
              established by a treaty or other type of instrument governed by
              international law and possesses its own legal personality, such as
              the United Nations, the World Health Organization, etc.
            </Typography>
            <br />
            <Typography gutterBottom>
              <b>Family members of PEP or HIO:</b>
            </Typography>
            <br />
            <Typography gutterBottom>
              Family members of PEP or HIO are recognized as PEP or HIO by
              virtue of their family relationship. PEP and HIO family members
              include spouses or common-law partners, ex-spouse or ex-common-law
              partner, biological or adoptive children, parents, the parents of
              spouses or common-law partners, and siblings.
            </Typography>
            <br />
            <Typography gutterBottom>
              <b>Close Associates of PEP or HIO:</b>
            </Typography>
            <br />
            <Typography gutterBottom>
              A close associate is a person connected to a PEP or a HIO for
              personal or business reasons. Examples include business partners,
              persons in a romantic relationship with a PEP or a HIO, and
              persons involved in financial transactions with a PEP or a HIO.
            </Typography>
            <Box mt={3} display="flex" justifyContent="flex-end">
              <OutlinedButton onClick={handleClosePEP} variant="outlined">
                Cancel
              </OutlinedButton>
            </Box>
          </ModalContent>

          {/* Same cred error modal */}
          <ModalContent
            open={sameCredConfirmation}
            onClose={() => setSameCredConfirmation(false)}
            title="Error"
          >
            <Typography paragraph>
              The {watch("ownerType")} being added is not unique. Please add a
              new {watch("ownerType")} to proceed.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
            >
              <ContainedButton
                variant="contained"
                size="small"
                onClick={() => setSameCredConfirmation(false)}
              >
                Okay
              </ContainedButton>
            </Box>
          </ModalContent>

          {/* Action Buttons */}
          <Box sx={{ ...actionRow, justifyContent: "flex-end" }}>
            <ContainedButton
              variant="contained"
              onClick={handleBackshowmsg}
              sx={{ ...submitBtn, opacity: 0.85 }}
              disabled={
                userDetails?.userDocsStatus === "0" &&
                userDetails?.isKycFinished === 0
              }
            >
              Back
            </ContainedButton>
            <ContainedButton
              variant="contained"
              sx={submitBtn}
              onClick={() => setFinalKycModal(true)}
              disabled={!owners?.length}
            >
              Finish KYC
            </ContainedButton>
          </Box>
        </Box>
      )}

      {steps > 5 && <IDTier2 />}
    </>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const card = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  p: { xs: 2.5, md: 3 },
};

const stepHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  mb: 2.5,
  flexWrap: "wrap",
};

const stepBadge = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const stepTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const stepCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.2,
};

const actionRow = {
  mt: 3.5,
  pt: 2.5,
  borderTop: "1px solid rgba(125,125,125,0.12)",
  display: "flex",
  gap: 1.5,
};

const submitBtn = {
  height: 48,
  px: 4,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
};

export default BeneficialOwners;

const autocompleteSx = {
  "& .MuiInputBase-root": {
    backgroundColor: "var(--popup-body-less)",
    color: "white",
    fontSize: "12px",
    borderRadius: "5px",
    padding: "0px 5px",
  },
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
  "& .MuiSvgIcon-root": { color: "white" },
};
